import { useState, useRef } from 'react';
import Progression from './Progression';

import { useUploadApi } from '../actions';
import { useList } from '../selectors';
import { UploadAllIcon } from './icons';

function UploadFile({ multiple }) {
  const [files, setFiles] = useState([]);
  const uploads = useList();
  const fileInputRef = useRef();
  const { send } = useUploadApi();

  const handleChange = ({ target }) => {
    setFiles(Array.from(target.files));
  };

  const handleUpload = async () => {
    fileInputRef.current.value = '';
    setFiles([]);
    for (const file of files) {
      send(file);
    }
  };

  return (
    <div>
      <div>
        {uploads.map(({ uuid }) => (
          <Progression
            key={uuid}
            uuid={uuid}
          />
        ))}
      </div>
      <div>
        <input
          className='file-input'
          type='file'
          multiple={multiple}
          onChange={handleChange}
          ref={fileInputRef}
        />
        <button
          className='btn btn-primary'
          onClick={handleUpload}
          disabled={files.length === 0}
        >
          <UploadAllIcon />
        </button>
      </div>
    </div>
  );
}

export default UploadFile;
